import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { HEURES_TRAVAILLES_DATA } from "../../models/data.model";
import { SharedModule } from "../../../../shared/shared.module";
import { Widget } from "../../models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { WidgetTitleComponent } from "../../../../shared/components/widget-title/widget-title.component";
import { UserInfoCardComponent } from "../../../../shared/components/user-info-card/user-info-card.component";
import { TimeUtils } from "../../../../shared/utils/time.utils";
import { ExpandButtonComponent } from "../../../../shared/components/expand-button/expand-button.component";

@Component({
  selector: "vl-widget-heures-travailles",
  standalone: true,
  imports: [
    SharedModule,
    WidgetTitleComponent,
    UserInfoCardComponent,
    ExpandButtonComponent,
  ],
  templateUrl: "./widget-heures-travailles.component.html",
  styleUrl: "./widget-heures-travailles.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetHeuresTravaillesComponent {
  data = input<HEURES_TRAVAILLES_DATA>();
  metadata = input<EntityMetadata>();
  widget = input<Widget>();

  dataComputed = computed(() => {
    if (this.heures()) {
      return this.heures().map((d) => ({
        ...d,
        dureeTotale: TimeUtils.sumTimes(d.travaux.map((t) => t.duree)),
      }));
    }

    return null;
  });

  heures = computed(() => {
    return (this.data() as HEURES_TRAVAILLES_DATA)?.data;
  });

  expanded: string;

  expandUser(userInfosId: string) {
    if (this.expanded == userInfosId) {
      this.expanded = null;
    } else {
      this.expanded = userInfosId;
    }
  }
}
